import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IAuthStrategy } from './auth-strategy.interface';
import { 
    IAuthResponse, 
    IGoogleAuthCredentials, 
    ILoginPayload,
    AuthType 
} from '../../models/auth.models';
import { WebService } from '../web/web.service';
import { LoggerService } from '../logger.service';

/**
 * Estrategia de autenticación con Google
 * Implementa el patrón Strategy
 */
@Injectable({
    providedIn: 'root'
})
export class GoogleAuthStrategy implements IAuthStrategy {
    private readonly loginUrl: string;

    constructor(
        private http: HttpClient,
        private webService: WebService,
        private logger: LoggerService
    ) {
        this.loginUrl = `${this.webService.HOST}/auth/login`;
    }

    authenticate(credentials: IGoogleAuthCredentials): Observable<IAuthResponse> {
        const payload: ILoginPayload = {
            username: credentials.username,
            partner: null,
            authType: AuthType.GOOGLE,
            googleToken: credentials.googleToken
        };

        return this.http.post<IAuthResponse>(this.loginUrl, payload, { withCredentials: true });
    }
}
